<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <div id="artifact-preview">
        <h3>{{name}}</h3>
        <div class="copy-content-container">
            <transition name="slide">
                <span v-if="showCopied" class="copied-message">Copied ✓</span>
            </transition>
            <span id="copy-content"
                class="material-icons cursor-pointer pl-5"
                alt="Copy to clipboard"
                title="Copy to clipboard"
                @click="copyContent"
                @keyup.enter="copyContent"
                tabindex="0"
            >
                content_copy
            </span>
        </div>
        <pre>{{renderedContent}}</pre>
    </div>
</template>
<script>
export default {
    name: 'ArtifactPreview',

    props: {
        content: String,
        name: String,
    },

    data() {
        return {
            showCopied: false,
        };
    },

    methods: {
        copyContent() {
            this.$clipboard(this.renderedContent);
            this.showCopied = true;
            setTimeout(() => {
                this.showCopied = false;
            }, 2000);
        },
    },

    computed: {
        renderedContent() {
            return this.content.replaceAll('\u001b[1000D\u001b[J', '\n');
        },
    },
};
</script>
<style lang="scss">
#artifact-preview {
    height: 100%;

    pre {
        padding: 10px;
        height: calc(100% - 75px);
    }
}
.copy-content-container {
    display: flex;
    align-items: center;
    position: absolute;
    right: 50px;
    top: 90px;

    span {
        line-height: 28px;
    }

    .copied-message {
        font-size: 14px;
        position: relative;
    }
}
.slide-enter-active {
  animation: slide .5s;
}
.slide-leave-active {
  animation: slide .5s reverse;
}
@keyframes slide {
    0% {
        left: 64px;
        opacity: 0;
    }
    33% {
        opacity: 0;
    }
    100% {
        left: 0;
        opacity: 1;
    }
}
</style>
